import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserManager } from 'oidc-client';
import { TableObject } from 'src/app/models/tableObject';
import { UserIdentity } from 'src/app/models/user-identity';
import { Md5 } from 'ts-md5';
import { ConstService } from '../user-services/const.service';

@Injectable({
  providedIn: 'root'
})
export class GestioneUtentiService {

  userManager: UserManager;

  constructor(
    private http: HttpClient,
    private identityUris: ConstService
  ) { }

  public getFormData(): Promise<{ roles: Array<string>, usersTotalCount: number }> {
    const md5 = new Md5();
    const hash = md5.appendStr('angular').end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash);

    return new Promise((resolve, reject) => {
      this.http.get(this.identityUris.formDataUri, { params: queryParams })
        .toPromise()
        .then(
          (res: { roles: Array<any>, usersTotalCount: number }) => resolve(res),
          (error: any) => reject(error)
        );
    });
    // const data = this.http.get(this.identityUris.formDataUri, { params: queryParams }).toPromise();
    // return this.http.get(this.identityUris.formDataUri, { params: queryParams }).toPromise();
  }

  public getUsersIdentifiers(): Promise<{ [username: string]: string } | void> {
    return new Promise((resolve, reject) => {
      this.http.get<any>(`${this.identityUris.getProfileUri()}/Identifiers/${true}`)
        .toPromise()
        .then(
          (usersIdentifiers: { [username: string]: string }) => {
            resolve(usersIdentifiers);
          },
          (error: any) => reject(error)
        );
    });
  }

  public getUsers(page: number): Promise<TableObject<UserIdentity>> {
    const md5 = new Md5();
    const hash = md5.appendStr('angular').end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash)
      .set('page', page.toString());

    return new Promise((resolve, reject) => {
      this.http.get(`${this.identityUris.usersUri}`, { params: queryParams })
        .toPromise()
        .then(
          (users: TableObject<UserIdentity>) => resolve(users),
          (error: any) => reject(error)
        );
    });
  }

  public searchByUsernameOrEmail(filter: string, page: number): Promise<TableObject<UserIdentity>> {
    const md5 = new Md5();
    const hash = md5.appendStr('angular').end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash)
      .set('username', filter)
      .set('page', page.toString());

    return new Promise((resolve, reject) => {
      this.http.get(this.identityUris.searchByUsernameOrEmailUri, { params: queryParams })
        .toPromise()
        .then(
          (searchData: TableObject<UserIdentity>) => resolve(searchData),
          (error: any) => reject(error)
        );
    });
  }

  public searchByRoleId(roleId: number, page: number): Promise<TableObject<UserIdentity>> {
    const md5 = new Md5();
    const hash = md5.appendStr('angular').end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash)
      .set('roleId', roleId.toString())
      .set('page', page.toString());

    return new Promise((resolve, reject) => {
      this.http.get(this.identityUris.searchByRoleIdUri, { params: queryParams })
        .toPromise()
        .then(
          (searchData: TableObject<UserIdentity>) => resolve(searchData),
          (error: any) => reject(error)
        );
    });
  }

  public searchByProduct(idSet: number[]): Promise<UserIdentity[]> {
    const md5 = new Md5();
    const hash = md5.appendStr('angular').end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash);

    return new Promise((resolve, reject) => {
      this.http.post(this.identityUris.searchByIdUri, idSet, { params: queryParams })
        .toPromise()
        .then(
          (users: UserIdentity[]) => resolve(users),
          (error: any) => reject(error)
        );
    });
  }

  public saveUserChanges(userModel: any): Promise<any> {
    const md5 = new Md5();
    const hash = md5.appendStr('angular').end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash);

    return new Promise((resolve, reject) => {
      this.http.post(this.identityUris.userChangesUri, userModel, { params: queryParams })
        .toPromise()
        .then(
          () => resolve(true),
          (error: any) => reject(error)
        );
    });
  }



  public sendEmail(emailModel: any): Promise<any> {
    const md5 = new Md5();
    const hash = md5.appendStr('angular').end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash);

    return new Promise((resolve, reject) => {
      this.http.post(this.identityUris.sendingMailUri, emailModel, { params: queryParams })
        .toPromise()
        .then(
          () => resolve(true),
          (error: any) => reject(error)
        );
    });
  }

  public resetPassword(resetModel: any): Promise<any> {
    const md5 = new Md5();
    const hash = md5.appendStr('angular').end().toString();

    const queryParams = new HttpParams()
      .set('clientId', hash);

    return new Promise((resolve, reject) => {
      this.http.post(this.identityUris.resetPasswordUri, resetModel, { params: queryParams })
        .toPromise()
        .then(
          () => resolve(true),
          (error: any) => reject(error)
        );
    });
  }

}
